import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import SupplierForm from './SupplierForm';
import { getSupplier, updateSupplier } from '../../collections/suppliers';
import { CircularProgress, Box } from '@mui/material';

const EditSupplier = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [supplier, setSupplier] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSupplier = async () => {
      try {
        setLoading(true);
        const data = await getSupplier(id);
        setSupplier(data);
      } catch (error) {
        toast.error('Lấy dữ liệu nhà cung cấp thất bại.');
      } finally {
        setLoading(false);
      }
    };
    fetchSupplier();
  }, [id]);

  const handleUpdateSupplier = async (formData) => {
    try {
      await updateSupplier(id, formData);
      toast.success('Cập nhật nhà cung cấp thành công!', {
        position: 'top-center',
        autoClose: 2000,
      });
      navigate('/suppliers');
    } catch (error) {
      let errorMessage = "Đã xảy ra lỗi không xác định!";
      if (error.response?.data?.error) {
        errorMessage = Object.values(error.response.data.error).flat().join('; ');
      }
      toast.error(errorMessage, {
        position: 'top-center',
        autoClose: 3000,
      });
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!supplier) {
    return <p>Không tìm thấy nhà cung cấp.</p>;
  }

  return (
    <SupplierForm
      onSubmit={handleUpdateSupplier}
      initialData={supplier}
      isEdit={true}
    />
  );
};

export default EditSupplier; 